export default __webpack_public_path__ + "static/media/IMG_1632.98d21265.jpg";